import { TheMask } from 'vue-the-mask'
import countTo from 'vue-count-to'

export default {
  TheMask,
  countTo
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/afters/resources/components.js